<template>
  <div
    class="row max-w-max"
    role="alert"
    aria-live="polite"
    aria-relevant="additions"
    aria-atomic="true"
    :aria-label="'Notification ' + message"
    tabindex="-1"
  >
    <div class="flex w-full justify-center items-center">
      <div
        class="col transition-all duration-1000 ease-linear absolute top-32 max-w-max opacity-0 flex justify-center"
        :class="{ 'opacity-100 z-10': visible, 'z-0': !visible }"
      >
        <p
          class="text-left whitespace-pre-wrap bg-grey-body text-white inline-block shadow-[0_2px_16px_0_rgb(0,0,0,0.2)] rounded-xl p-16 leading-normal flex"
        >
          <span>{{ message }}</span>
          <button :tabindex="visible ? 0 : -1" aria-label="Close" class="modal-close ml-16" @click="hideNotification">
            <Close class="ml-8" color="white" :height="10" :width="10" />
          </button>
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Close from '../../graphics/icons/CloseIconMini.vue';

export default {
  name: 'Notification',
  components: { Close },
  props: {
    triggerNotification: {
      default: false,
      type: Boolean,
    },
    message: {
      default: '',
      type: String,
    },
    customTimeout: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      visible: false,
      timeout: this.customTimeout,
      timeoutId: 0,
    };
  },
  watch: {
    triggerNotification() {
      this.visible = this.triggerNotification;
    },
    visible() {
      // clear previous timeout before new one
      window.clearTimeout(this.timeoutId);
      this.timeoutId = window.setTimeout(() => {
        this.hideNotification();
      }, this.timeout);
    },
  },
  mounted() {
    if (this.triggerNotification) this.visible = true;
  },
  methods: {
    hideNotification() {
      this.visible = false;
      this.$emit('toggleVisibility');
    },
  },
};
</script>
